export default __webpack_public_path__ + "static/media/enterWithPWRS.e79d614a.png";